import { useMutation, useQuery } from "@tanstack/react-query";
import apiServices from "../ApiServices/request-handler";
import { SwalAlert } from "../components";
import Analytics from "../firebase_services/analytics";
import { useNavigate } from "react-router-dom";

const fetchAgencyList = async ({ queryKey }) => {
  const [, recordType] = queryKey;
  const response = await apiServices.partnerAndAgency(recordType);
  return response?.data?.data;
};
export const useAgency = (recordType) => {
  return useQuery({
    queryKey: ["agency", recordType],
    queryFn: fetchAgencyList,
    enabled: recordType !== null && recordType !== undefined,
  });
};

const fetchVolteList = async ({ queryKey }) => {
  const [, userId, per_page] = queryKey;
  const response = await apiServices.voteImages(userId, per_page);
  return response?.data;
};
export const useTalentVolteList = (userId, per_page) => {
  return useQuery({
    queryKey: ["talentVolteList", userId, per_page],
    queryFn: fetchVolteList,
  });
};

export const useVoteMutation = (
  setLoadingToHotapi,
  setLoadingToNotapi,
  queryClient,
  setCurrentIndex,
  filteredTalentList
) => {
  return useMutation({
    mutationFn: async (voteData) => {
      const response = await apiServices.vote(voteData);
      return response.data;
    },
    onSuccess: (data) => {
      setLoadingToHotapi(false);
      setLoadingToNotapi(false);
      const title = data.status;
      const message = data.message;
      SwalAlert(title, message, "success");
      // queryClient.invalidateQueries(["talentVolteList"]);
      setCurrentIndex(
        (prevIndex) => (prevIndex + 1) % filteredTalentList?.length
      );
      // setCurrentIndex((prevIndex) => {
      //     const nextIndex = (prevIndex + 1) % filteredTalentList.length;
      //     return nextIndex;
      // });
      setCurrentIndex(0);
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
      setLoadingToHotapi(false);
      setLoadingToNotapi(false);
    },
  });
};

const fetchTalentList = async (isHomepage, page, filters) => {
  const response = await apiServices.talent({
    page: page,
    is_homepage: isHomepage ? 1 : 0,
    ...(filters || {}),
  });
  return response?.data?.data;
};
export const useTalent = (isHomepage, page, pervData, filters) => {
  return useQuery({
    queryKey: ["talentList", isHomepage, page],
    queryFn: () => fetchTalentList(isHomepage, page, filters),
    keepPreviousData: pervData ? true : false,
  });
};

const fetchmaincategory = async ({ queryKey }) => {
  const [, type, showOnHomePage] = queryKey; 
  const response = await apiServices.categoriesTypes(
    type,
    showOnHomePage ? 10 : 100
  );
  return response?.data?.data;
};

const fetchmaincategoriesall = async ({ queryKey }) => {
  try {
    const [, type, showOnHomePage] = queryKey;
    let page = 1;
    let hasMore = true;
    let allData = [];
    
    while (hasMore) {  
      const res = await apiServices.categoriesTypesWithPagination(
        type,
        100,
        page
      ); 
      const json = res; // await res.json(); 
      if (json?.data?.data?.categories) {
        allData = [...allData, ...json.data.data.categories];
      }

      hasMore = json?.data?.data?.has_more_pages; 
      page++;
    } 
    return allData;
  } catch (error) {
    console.log('Error fetching all categories:', error);
    return [];
  }
};

export const useMaincategory = (type, showOnHomePage) => { 
  return useQuery({
    queryKey: ["maincategory", type, showOnHomePage],
    queryFn: fetchmaincategory,
    enabled: type !== null && type !== undefined,
  });
};

export const useMainAllcategory = (type, showOnHomePage) => { 
  return useQuery({
    queryKey: ["maincategory", type, showOnHomePage],
    queryFn: fetchmaincategoriesall,
    enabled: type !== null && type !== undefined,
  });
};

const fetchEvents = async ({ queryKey }) => {
  const [, page, per_page] = queryKey;
  const response = await apiServices.events({
    page: page,
    per_page: per_page ? per_page : 10,
  });
  return response?.data?.data;
};
export const useEvents = (page, per_page) => {
  return useQuery({
    queryKey: ["Events", page, per_page],
    queryFn: fetchEvents,
  });
};

const fetchNewsList = async ({ queryKey }) => {
  const [, page, per_page] = queryKey;
  const response = await apiServices.news({
    page: page,
    per_page: per_page ? per_page : 10,
  });
  return response?.data?.data;
};
export const useNews = (page, per_page) => {
  return useQuery({
    queryKey: ["newsList", page, per_page],
    queryFn: fetchNewsList,
  });
};

const fetchProjectList = async ({ queryKey }) => {
  const [, page, per_page] = queryKey;
  const response = await apiServices.projects(page, per_page ?? 10);
  return response?.data?.data;
};

export const useProject = (page, per_page = 10) => {
  return useQuery({
    queryKey: ["project", page, per_page],
    queryFn: fetchProjectList,
  });
};

const fetchJobsListing = async ({ queryKey }) => {
  const [, per_page, isHomepage, userId] = queryKey;
  const response = await apiServices.job(
    userId,
    isHomepage ? 1 : 0,
    per_page ? 6 : 0
  );
  return response?.data?.data;
};

export const useJobListing = (per_page, isHomepage, userId) => {
  return useQuery({
    queryKey: ["jobslisting", per_page, isHomepage, userId],
    queryFn: fetchJobsListing,
  });
};

const fetchMain = async ({ queryKey }) => {
  const [, mainId] = queryKey;
  const response = await apiServices.categoriesId(mainId);
  return response?.data?.data;
};

export const useMain = (categoriesTtypesMainId) => {
  return useQuery({
    queryKey: ["Main", categoriesTtypesMainId],
    queryFn: fetchMain,
    enabled:
      categoriesTtypesMainId !== null && categoriesTtypesMainId !== undefined,
  });
};

const fetchportfolio = async ({ queryKey }) => {
  const [, talentId] = queryKey;
  const userId = localStorage.getItem("userId");
  const response = await apiServices.talentPortfolio(talentId, userId);
  return response?.data?.data;
};

export const usePortfolio = (talentId) => {
  return useQuery({
    queryKey: ["portfolio", talentId],
    queryFn: fetchportfolio,
    enabled: talentId !== null && talentId !== undefined,
  });
};

const fetchEventsList = async ({ queryKey }) => {
  const [, eventId] = queryKey;
  const userId = localStorage.getItem("userId");
  const response = await apiServices.singleEventList(eventId, userId);
  return response?.data?.data;
};

export const useSingleEventList = (eventId) => {
  return useQuery({
    queryKey: ["singleEvent", eventId],
    queryFn: fetchEventsList,
    enabled: eventId !== null && eventId !== undefined,
  });
};

const fetchSavedJobs = async ({ queryKey }) => {
  const [, userId, talentId, page] = queryKey;
  const response = await apiServices.getSavedJobs(page, talentId, userId);
  return response?.data?.data;
};

export const useSavedJob = (userId, talentId, page) => {
  return useQuery({
    queryKey: ["SavedJobs", userId, talentId, page],
    queryFn: fetchSavedJobs,
    enabled: !!talentId,
  });
};

const fetchTeamsList = async ({ queryKey }) => {
  const [, id] = queryKey;
  const response = await apiServices.teams(id, 10);
  return response?.data?.data;
};

export const useTeams = (id) => {
  return useQuery({
    queryKey: ["teams", id],
    queryFn: fetchTeamsList,
  });
};

const fetchMisssionSHEList = async ({ queryKey }) => {
  const [, page] = queryKey;
  const response = await apiServices.missionSHE(page);
  return response?.data?.data;
};

export const useMisssionSHE = (page) => {
  return useQuery({
    queryKey: ["MisssionSHE", page],
    queryFn: fetchMisssionSHEList,
  });
};

const fetchSingleMissionSHE = async ({ queryKey }) => {
  const [, mission_sheId] = queryKey;
  const response = await apiServices.missionSHEDeatils(mission_sheId);
  return response?.data?.data;
};

export const useSingleMission_she = (Mission_sheId) => {
  return useQuery({
    queryKey: ["singleMission_she", Mission_sheId],
    queryFn: fetchSingleMissionSHE,
    enabled: Mission_sheId !== null && Mission_sheId !== undefined,
  });
};

const fetchSingleNewsList = async ({ queryKey }) => {
  const [, newsId] = queryKey;
  const userId = localStorage.getItem("userId");
  const response = await apiServices.newsDeatils(newsId, userId);
  return response?.data?.data;
};

export const useSingleNews = (newsId) => {
  return useQuery({
    queryKey: ["singleNews", newsId],
    queryFn: fetchSingleNewsList,
    enabled: newsId !== null && newsId !== undefined,
  });
};

const fetchSingleProject = async ({ queryKey }) => {
  const [, projectId] = queryKey;
  const response = await apiServices.singleProject(projectId);
  return response?.data?.data;
};

export const useSingleProject = (projectId) => {
  return useQuery({
    queryKey: ["singleProject", projectId],
    queryFn: fetchSingleProject,
    enabled: projectId !== null && projectId !== undefined,
  });
};

export const useHiremeMutation = (
  setLoadingToapi,
  setShowForm,
  setsuccess,
  reset
) => {
  return useMutation({
    mutationFn: async (hireMeData) => {
      const response = await apiServices.hireme(hireMeData);
      return response.data;
    },
    onSuccess: (data) => {
      SwalAlert(data?.status, data?.message, "success");
      setLoadingToapi(false);
      setShowForm(false);
      setsuccess(true);
      reset();
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      setLoadingToapi(false);
      SwalAlert("Oops...", message, "error");
    },
  });
};

export const useMutationFavouritelike = (setLoadingapi) => {
  return useMutation({
    mutationFn: async (favouriteAndLikeData) => {
      const response = await apiServices.favouritelike(favouriteAndLikeData);
      return response.data;
    },
    onSuccess: (data) => {
      setLoadingapi(false);
      SwalAlert("Success!", data?.message, "success");
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
      setLoadingapi(false);
    },
  });
};

const fetchTeamsPagenationList = async ({ queryKey }) => {
  const [, page] = queryKey;
  const response = await apiServices.teamsPagenation(page);
  return response?.data?.data;
};

export const useTeamsPagenation = (page) => {
  return useQuery({
    queryKey: ["teamsPagenation", page],
    queryFn: fetchTeamsPagenationList,
  });
};

export const UsecontactUsMutation = (navigate, setLoading) => {
  return useMutation({
    mutationFn: async (contactusData) => {
      const response = await apiServices.contactUs(contactusData);
      return response.data;
    },
    onSuccess: async (data) => {
      const message = data.message;
      SwalAlert("Success!", message, "success");
      navigate("/");
      setLoading(false);
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      setLoading(false);
      SwalAlert("Oops...", message, "error");
    },
  });
};

export const useFavouritelikeMutation = (setLoadingapi) => {
  return useMutation({
    mutationFn: async (favouritelikeData) => {
      const response = await apiServices.favouritelike(favouritelikeData);
      return response.data;
    },
    onSuccess: (data) => {
      setLoadingapi(false);
      const title = data.status;
      const message = data.message;
      SwalAlert(title, message, "success");
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
      setLoadingapi(false);
    },
  });
};

export const UseSubscriptionMutation = (setLoading) => {
  return useMutation({
    mutationFn: async (subscriptionData) => {
      const response = await apiServices.newsletterSubscription(subscriptionData);
      return response.data;
    },
    onSuccess: async (data) => {
      const message = data.message;
      SwalAlert("Success!", message, "success"); 
      setLoading(false);
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      setLoading(false);
      SwalAlert("Oops...", message, "error");
    },
  });
};